var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_terms-and-policy-error-container"},[_c('h2',{staticStyle:{"text-align":"center"}},[_vm._v(" "+_vm._s(_vm.$t('booking.summary.termsAndPolicyError'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }